import { Fragment } from 'react';
import styles from './PHChart.module.css';
import type { FixedParam } from '../../../types/parameters.types';

interface PHChartProps {
	param: FixedParam;
}

const SEGMENTS = [
	{ value: '≤5,0', label: 'Elevada', colorVar: '--ph-acidez-elevada' },
	{ value: '5,0-5,9', label: 'Média', colorVar: '--ph-acidez-media' },
	{ value: '6,0-6,9', label: 'Fraca', colorVar: '--ph-acidez-fraca' },
	{ value: '7,0', label: '', colorVar: '--ph-neutro' },
	{ value: '7,1-7,8', label: 'Fraca', colorVar: '--ph-alcal-fraca' },
	{ value: '7,9-8,2', label: 'Média', colorVar: '--ph-alcal-media' },
	{ value: '>8,2', label: 'Elevada', colorVar: '--ph-alcal-elevada' },
];

const DOMAINS = [
	{ label: 'Acidez', span: 3 },
	{ label: 'Neutro', span: 1 },
	{ label: 'Alcalinidade', span: 3 },
];

export const PHChart = ({ param: _param }: PHChartProps) => (
	<div className={styles.wrapper}>
		<div className={styles.title}>
			PH em H<sub className={styles.titleSub}>2</sub>O (Acidez Ativa)
		</div>

		<div className={styles.domainsRow}>
			{DOMAINS.map((d) => (
				<span key={d.label} className={styles.domainLabel} style={{ flex: d.span }}>
					{d.label}
				</span>
			))}
		</div>

		<div className={styles.track}>
			{SEGMENTS.map((seg, i) => (
				<Fragment key={seg.value}>
					<div className={styles.segment}>
						<span className={styles.segmentValue} style={{ color: `var(${seg.colorVar})` }}>
							{seg.value}
						</span>
						{seg.label && <span className={styles.segmentLabel}>{seg.label}</span>}
					</div>
					{i < SEGMENTS.length - 1 && <div className={styles.divider} />}
				</Fragment>
			))}
		</div>
	</div>
);
